/* global moment */
import { auth } from "@/services";
import { UserNotificationsService } from "@/services/api";
import { defaultsDeep } from "lodash";
import { notifications } from "@/services";

(function createManageUserController(angular) {
  angular
    .module("app")
    .controller("manageUserController", manageUserController);

  manageUserController.$inject = [
    "$rootScope",
    "$scope",
    "$timeout",
    "$uibModalInstance",
    "$window",
    "BusinessInterestsApi",
    "confirmDialog",
    "ConnectsApi",
    "Events",
    "EventOrdersApi",
    "handleError",
    "industries",
    "locations",
    "queryParams",
    "rolesApi",
    "thisSiteSettings",
    "UploadsApi",
    "userDefaults",
    "UsersApi",
    "Users",
    "userId",
    "mfaSetupApi",
    "mfaApi",
    "mfaResetApi",
  ];

  function manageUserController(
    $rootScope,
    $scope,
    $timeout,
    $uibModalInstance,
    $window,
    BusinessInterestsApi,
    confirmDialog,
    ConnectsApi,
    Events,
    EventOrdersApi,
    handleError,
    industries,
    locations,
    queryParams,
    rolesApi,
    thisSiteSettings,
    UploadsApi,
    userDefaults,
    UsersApi,
    Users,
    userId,
    mfaSetupApi,
    mfaApi,
    mfaResetApi,
  ) {
    const vm = this;
    let loadedMemberConnections = false;
    let loadedMemberEvents = false;
    let loadedMemberPackages = false;

    vm.user_mfa_setup = false;

    vm.mfa_setup = {
      qr: null,
      secret: null,
      active: false,
      working: false,
      verifier_input: "",
      recovery_codes: null,
    };

    // properties
    vm.activeOptions = [
      { label: "Active", value: 1 },
      { label: "Inactive", value: 0 },
    ];
    vm.createNewUser = !userId;
    vm.formErrors = {};
    vm.industries = industries;
    vm.imageUploadOptions = {
      resize: true,
      resizeShape: "square",
      resizeSize: { w: 200, h: 200 },
    };
    vm.interests = {
      data: [],
    };
    vm.isLoading = false;
    vm.isLoadingConnections = false;
    vm.isLoadingEvents = false;
    vm.isLoadingProgress = 0;
    vm.permissionChecks = {
      canDelete: false,
      canManage: auth.hasPermission("users.update"),
      canChangeRole: auth.hasPermission("roles.manage", "users.set.role_id"),
      canChangeActiveStatus: auth.hasPermission("users.set.is_active"),
    };
    vm.queryParams = queryParams;

    vm.saveable = true;
    vm.disableSave = () => {
      vm.saveable = false;
    };
    vm.enableSave = () => {
      vm.saveable = true;
    };

    // show a required form error for these attributes
    vm.requiredValues = ["title", "forename", "surname", "email"];
    // add required custom attributes to vm.requiredValues
    angular.forEach(thisSiteSettings.user_attrs, (attr) => {
      if (attr.required) {
        const prefix = attr.custom ? "custom_attrs." : "";
        vm.requiredValues.push({
          field: prefix + attr.key,
          message: `${attr.label} is required`,
        });
      }
    });

    vm.roles = [];
    vm.settings = thisSiteSettings.email_digest;
    vm.site_mfa_enabled = thisSiteSettings.mfa_enabled;
    vm.thisUser = $rootScope.thisUser;
    vm.user = {
      title: "Mr",
      gender: "",
      img: "",
      interests: [],
    };
    vm.userAttrsConfig = thisSiteSettings.user_attrs;

    vm.watch = false;
    vm.currencySymbol = thisSiteSettings.currency_symbol;

    // methods
    vm.close = $uibModalInstance.close;
    vm.deleteUser = deleteUser;
    vm.editEvent = Events.edit;
    vm.editUser = Users.edit;
    vm.filterBusinessInterests = filterBusinessInterests;
    vm.humaniseKey = humaniseKey;
    vm.handleImage = handleImage;
    vm.handleImageError = handleImageError;
    vm.removeImage = removeImage;
    vm.save = save;
    vm.updateLocation = updateLocation;
    vm.handleBioChange = handleBioChange;
    vm.mfaSetup = mfaSetup;
    vm.mfaVerify = mfaVerify;
    vm.mfaReset = () => {
      if (vm.mfa_setup.working) {
        return;
      }
      vm.mfa_setup.working = true;

      mfaResetApi.save(vm.user.id !== vm.thisUser.id ? { user_id: vm.user.id } : {}).$promise.then(() => {
        if (vm.user.id !== vm.thisUser.id) {
          notifications.display({
            message: "If setup, the user's Multi-Factor Authentication has been reset.",
            theme: "success",
            title: "Multi-Factor Authentication Reset",
          });
        }
        vm.mfa_setup.active = false;
        vm.mfa_setup.qr = null;
        vm.mfa_setup.secret = null;
        vm.user_mfa_setup = false;
      }).finally(() => {
        vm.mfa_setup.working = false;
      });
    };

    // Get settings for each attribute
    vm.dobSettings = vm.userAttrsConfig.find(
      (element) => element.key === "dob",
    );
    vm.telSettings = vm.userAttrsConfig.find(
      (element) => element.key === "contactables.tel",
    );
    vm.mobSettings = vm.userAttrsConfig.find(
      (element) => element.key === "contactables.mob",
    );
    vm.websiteSettings = vm.userAttrsConfig.find(
      (element) => element.key === "contactables.website",
    );
    vm.citySettings = vm.userAttrsConfig.find(
      (element) => element.key === "address.city",
    );
    vm.postcodeSettings = vm.userAttrsConfig.find(
      (element) => element.key === "address.postcode",
    );
    vm.industrySettings = vm.userAttrsConfig.find(
      (element) => element.key === "industry",
    );
    vm.twitterSettings = vm.userAttrsConfig.find(
      (element) => element.key === "contactables.twitter",
    );
    vm.linkedinSettings = vm.userAttrsConfig.find(
      (element) => element.key === "contactables.linkedin",
    );
    vm.facebookSettings = vm.userAttrsConfig.find(
      (element) => element.key === "contactables.facebook",
    );
    vm.interestsSettings = vm.userAttrsConfig.find(
      (element) => element.key === "interests",
    );
    vm.companySettings = vm.userAttrsConfig.find(
      (element) => element.key === "company",
    );
    vm.titleSettings = vm.userAttrsConfig.find(
      (element) => element.key === "title",
    );
    vm.genderSettings = vm.userAttrsConfig.find(
      (element) => element.key === "gender",
    );
    vm.bioSettings = vm.userAttrsConfig.find(
      (element) => element.key === "bio",
    );
    vm.youtubeSettings = vm.userAttrsConfig.find(
      (element) => element.key === "youtube_url",
    );

    if (vm.thisUser.isAdmin || vm.thisUser.role === "super_admin") {
      vm.dobSettings.editable = true;
      vm.telSettings.editable = true;
      vm.mobSettings.editable = true;
      vm.websiteSettings.editable = true;
      vm.citySettings.editable = true;
      vm.postcodeSettings.editable = true;
      vm.industrySettings.editable = true;
      vm.twitterSettings.editable = true;
      vm.linkedinSettings.editable = true;
      vm.facebookSettings.editable = true;
      vm.interestsSettings.editable = true;
      vm.companySettings.editable = true;
      vm.titleSettings.editable = true;
      vm.genderSettings.editable = true;
      vm.bioSettings.editable = true;
      vm.youtubeSettings.editable = true;
    }

    /**
     * Deletes this user after confirming
     * @return {void}
     */
    function deleteUser() {
      if (!vm.permissionChecks.canDelete) {
        return;
      }

      confirmDialog("Are you sure you want to delete this user?").result.then(
        (confirm) => {
          if (confirm) {
            vm.isLoadingMessage = "Deleting...";
            vm.isLoading = true;

            const handleDeleteUserResponse = () => {
              vm.forceClose = true;
              $uibModalInstance.dismiss("deleted");

              if (vm.thisUser.id === vm.user.id) {
                $window.location = "/signout";
              }
            };
            const handleDeleteUserError = () => {
              vm.isLoading = false;
            };

            UsersApi.delete(
              { id: vm.user.id },
              handleDeleteUserResponse,
              handleDeleteUserError,
            );
          }
        },
      );
    }

    /**
     * Retrieves interests from the API for the filter control
     * @param  {string} search - Search string
     * @return {void}
     */
    function filterBusinessInterests(search) {
      if (search !== "") {
        BusinessInterestsApi.get(
          {
            name: search,
          },
          (response) => {
            vm.interests.data = response.data.map((result) => result.name);
          },
        );
      }
    }

    function humaniseKey(str) {
      var i,
        frags = str.split("_");
      for (i = 0; i < frags.length; i++) {
        frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
      }
      return frags.join(" ");
    }

    /**
     * Retrieves this member's connections from the API
     * @return {void}
     */
    function getMemberConnections() {
      vm.isLoadingConnections = true;

      const handleMemberConnectionsResponse = (response) => {
        vm.connections = response;
        loadedMemberConnections = true;
        vm.isLoadingConnections = false;
      };
      const handleMemberConnectionsError = (err) => {
        handleError(err);
        vm.isLoadingConnections = false;
      };

      ConnectsApi.get(
        {
          user_id_from: vm.user.id,
          with: "userTo",
          page_size: 100,
        },
        handleMemberConnectionsResponse,
        handleMemberConnectionsError,
      );
    }

    /**
     * Retrieves events this user is attending from the API
     * @return {void}
     */
    function getMemberEvents() {
      vm.isLoadingEvents = true;

      const handleMemberEventsResponse = (response) => {
        vm.eventOrders = response;
        loadedMemberEvents = true;
        vm.isLoadingEvents = false;
      };
      const handleMemberEventsError = (err) => {
        handleError(err);
        vm.isLoadingEvents = false;
      };

      EventOrdersApi.get(
        {
          user_id: vm.user.id,
          include_attended_by: vm.user.id,
          with: "event",
          page_size: 100,
        },
        handleMemberEventsResponse,
        handleMemberEventsError,
      );
    }

    /**
     * Get member packages from the API.
     * @return {void}
     */
    function getMemberPackages() {
      vm.isLoadingPackages = true;

      const handleMemberPackagesSuccess = (response) => {
        vm.activePackage = response.data[0];
        vm.isLoadingPackages = false;
        loadedMemberPackages = true;
      };
      const handleMemberPackagesError = (err) => {
        vm.isLoadingPackages = false;
        loadedMemberPackages = true;
        handleError(err);
      };

      UsersApi.getMemberPackages(
        {
          id: userId,
          expires_at_from: new Date(),
        },
        handleMemberPackagesSuccess,
        handleMemberPackagesError,
      );
    }

    /**
     * Retrieves roles from the api and assigns to vm.roles
     *
     * @returns {void}
     */
    function getRoles() {
      rolesApi.get().$promise.then((response) => {
        vm.roles = response.data;
      });
    }


    function mfaSetup() {
      if (vm.mfa_setup.working) {
        return;
      }

      vm.mfa_setup.working = true;

      mfaSetupApi.get().$promise.then((response) => {
        vm.mfa_setup.active = !vm.mfa_setup.active;
        vm.mfa_setup.qr = response.qr;
        vm.mfa_setup.secret = response.secret;
      }).finally(() => {
        vm.mfa_setup.working = false;
      });
    }

    function mfaVerify() {
      if (vm.mfa_setup.working) {
        return;
      }
      vm.mfa_setup.working = true;

      mfaSetupApi.save({ code: vm.mfa_setup.verifier_input }).$promise.then((response) => {
        vm.mfa_setup.active = true;
        vm.mfa_setup.recovery_codes = response.recovery_codes;
        vm.mfa_setup.verifier_input = '';
        vm.user_mfa_setup = true;
        notifications.display({
          theme: 'success',
          title: 'Multi-Factor Authentication Verification Successful',
          message: 'Your Multi-Factor Authentication has been successfully set up.',
        });
      }).finally(() => {
        vm.mfa_setup.working = false;
      });
    }

    function getMfaStatus() {
      mfaApi.get().$promise.then((response) => {
        vm.user_mfa_setup = response.active;
      });
    }

    /**
     * Retrieves notifications from the api and assigns to vm.notifications
     *
     * @returns {void}
     */
    function getNotifications() {
      UserNotificationsService.query(userId).then((response) => {
        vm.user.notifications = response;
      });
    }

    /**
     * Retrieves user's info from the API to be edited
     * @return {void}
     */
    function getUser() {
      vm.isLoading = true;
      vm.isLoadingMessage = "Loading user...";

      const handleGetUserResponse = (response) => {
        // update local user properties
        angular.extend(vm.user, response.data);
        vm.user.custom_attrs = vm.user.custom_attrs || {};
        vm.dob = new Date(vm.user.dob);
        vm.user.contactables.website = vm.user.contactables.website || "";
        vm.isLoading = false;
        // recalculate permissions
        updatePermissionChecks();
        $timeout(() => {
          vm.watch = true;
        }, 400);
      };
      const handleGetUserError = (err) => {
        vm.isLoading = false;
        vm.forceClose = true;
        $uibModalInstance.close();
        handleError(err);
      };

      UsersApi.get({ id: userId }, handleGetUserResponse, handleGetUserError);
    }

    /**
     * Handles the image chosen by the user
     * @param  {file} file - Provided by ngFileUpload plugin
     * @return {void}
     */
    function handleImage(image) {
      vm.image = image;
    }

    /**
     * Shows file errors
     * @param  {object} imageError - provided as  {image: '[error msg]'}
     * @return {void}
     */
    function handleImageError(imageError) {
      vm.formErrors = angular.merge(vm.formError, imageError);
    }

    /**
     * Removes a profile image.
     * @return {void}
     */
    function removeImage() {
      vm.isLoading = true;
      vm.isLoadingMessage = "Removing image...";

      UsersApi.update({ id: userId }, { img: null, img_src: null }, () => {
        vm.isLoading = false;
        vm.user.img = null;
        vm.user.img_src = null;
      });
    }

    /**
     * Attempts to create or update a member using the provided form data
     * @return {void}
     */
    function save() {
      /**
       * Uploads the new profile image if it has changed.
       *
       * @returns {Promise<void>}
       */
      const uploadProfileImage = () =>
        new Promise<void>((resolve, reject) => {
          if (vm.image) {
            vm.isLoadingMessage = "Uploading image...";
          } else {
            return resolve();
          }

          /**
           * Updates the local user object with the new image location
           * and resolves the promise.
           *
           * @param {{ path: string }} img
           * @returns {void}
           */
          const handleImageUploadSuccess = (img) => {
            // Hide progress bar
            vm.isLoadingProgress = false;

            // Add uploaded image location to user
            if (img && img.path) {
              vm.user.img = img.path;
            } else {
              vm.user.img = vm.user.img_src;
            }

            resolve();
          };

          /**
           * Updates scope when the upload progress changes.
           *
           * @param {number} progress
           * @returns {void}
           */
          const handleImageUploadProgress = (progress) => {
            vm.isLoadingProgress = progress;
          };

          UploadsApi.uploadImage(vm.image, "user").then(
            handleImageUploadSuccess,
            reject,
            handleImageUploadProgress,
          );
        });

      /**
       * Updates the existing user, or creates a new one.
       *
       * @returns {Promise<iUser>}
       */
      const saveUser = () =>
        new Promise((resolve, reject) => {
          let apiMethod;
          let params = {};

          /**
           * Resolves the promise with the updated user object.
           *
           * @param {{ data: iUser }} response
           * @returns {void}
           */
          const handleSaveUserResponse = (response) => {
            resolve(response.data);
          };

          /**
           * Applies form errors and rejects the promise.
           *
           * @param {any} err
           * @returns {void}
           */
          const handleSaveUserError = (err) => {
            if (err.data) {
              vm.formErrors = err.data;
            }

            reject(err);
          };

          // Switch api endpoint based on the role of this modal
          if (vm.createNewUser) {
            apiMethod = "save";
            params = {
              id: vm.userId,
            };
          } else {
            apiMethod = "update";
            params = {};
          }

          // Set a relevent loading message
          vm.isLoadingMessage = vm.createNewUser
            ? "Creating new user..."
            : "Saving user...";

          // Convert dates to utc and format
          vm.user.dob = window.moment(vm.dob).format("Y-MM-DD");

          // Update the user
          UsersApi[apiMethod](
            params,
            vm.user,
            handleSaveUserResponse,
            handleSaveUserError,
          ).suppressValidationAlerts();

          // Update user's notifications
          if (!vm.createNewUser) {
            UserNotificationsService.save(vm.user.notifications, userId);
          }
        });

      vm.isLoading = true;
      uploadProfileImage()
        .then(saveUser)
        .then((updatedUser) => {
          vm.isLoading = false;
          $uibModalInstance.close(updatedUser);
        })
        .catch((err) => {
          vm.isLoading = false;
          handleError(err);
        });
    }

    /**
     * Gets any required data for the member detail view and creates the member location map
     * @return {void}
     */
    function initDetailView() {
      locations.makeMap(vm.user.latlng, `#member-map-${vm.user.id}`);

      if (!loadedMemberConnections) {
        getMemberConnections();
      }
      if (!loadedMemberEvents) {
        getMemberEvents();
      }
      if (!loadedMemberPackages) {
        getMemberPackages();
      }
    }

    /**
     * Gets any required data for the member package tab
     * @return void
     */
    function initActivePackageView() {
      if (!loadedMemberPackages) {
        getMemberPackages();
      }
    }

    /**
     * Updates the user's coordinates with the first google location result
     * @param  {searchString} searchString - Location to search for (typically postcode)
     * @return {void}
     */
    function updateLocation(searchString) {
      locations.find(searchString).then((locationResults) => {
        if (locationResults[0]) {
          locations
            .getDetails(locationResults[0].placeId)
            .then((locationDetails) => {
              vm.user.latlng = locationDetails.coords;
            });
        }
      });
    }

    /**
     * Recalculates vm.permissionChecks
     *
     * @returns {void}
     */
    function updatePermissionChecks() {
      // whether the user is editing their own account details
      const user = auth.user();
      const isOwnAccount = user && user.data.id === vm.user.id;

      vm.permissionChecks = {
        ...vm.permissionChecks,
        canDelete: isOwnAccount || user.hasPermission("users.delete"),
      };
    }

    /**
     * Prepare state when the controller loads.
     */
    (function init() {
      // Set any defaults
      if (userDefaults) {
        angular.extend(vm.user, userDefaults);
        vm.dob = new Date(vm.user.dob);
      }

      getMfaStatus();

      // set initial permissions
      updatePermissionChecks();

      // load user data
      if (!vm.createNewUser) {
        getUser();
        getNotifications();
      }

      // load roles
      if (vm.permissionChecks.canChangeRole) {
        getRoles();
      }

      // watch tab changes
      $scope.$watch("activeTab", (activeTab) => {
        switch (activeTab) {
          case "details":
            initDetailView();
            break;
          case "active-package":
            initActivePackageView();
            break;
          default:
            break;
        }
      });

      $scope.$on("modal.closing", (event, reason, closed) => {
        if (!closed && !vm.forceClose) {
          return event.preventDefault();
        }
      });
    })();

    /**
     * Updates the user bio
     *
     * @param {string} bio html
     * @returns {void}
     */
    function handleBioChange(bio) {
      vm.user.bio = bio;
    }
  }
})(angular);
